import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-source',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss'],
})
export class DeleteSourceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
